// A card's word in an address (lib/card-words.js): one engine for the server and the app.
import engine from '../../../lib/card-words.js';

export const { EVERYTHING, wordOf, cardWords, fileWordOf } = engine;
